import {
  getNetworks,
  getNetworksStatistic,
  getNetworksStatuses,
  deleteNetwork,
  networkShow,
  uploadImage,
  updateNetwork,
  createNetwork,
  networkGroups,
  networkTags,
} from '../../api/networksApi'
import { Message } from 'element-ui'
import { userShow } from '../../api/users'
import router from '../../router'

const state = {
  networks: [],
  networksStatuses: [],
  networksStatistic: [],
  meta: {},
  networkShow: {
    logo_name: null
  },
  networkGroups: [],
  networkGroupsFilter: [],
  networkTags: [],
}

const getters = {
  getNetworks: state => state.networks,
  getNetworksStatistic: state => state.networksStatistic,
  getNetworksStatuses: state => state.networksStatuses,
  getNetworksMeta: state => state.meta,
  getNetworkShow: state => state.networkShow,
  getNetworkGroups: state => state.networkGroups,
  getNetworkGroupsFilter: state => state.networkGroupsFilter,
  getNetworkTags: state => state.networkTags,
}

const mutations = {
  SET_NETWORKS: (state, payload) => {
    state.networks = payload.data
    state.meta = payload.meta
  },
  SET_NETWORKS_STATUSES: (state, payload) => {
    state.networksStatuses = payload
  },
  SET_NETWORKS_STATISTIC: (state, payload) => {
    state.networksStatistic = payload
  },
  SET_NETWORK_SHOW: (state, payload) => {
    state.networkShow = payload
  },
  SET_NETWORK_GROUPS: (state, payload) => {
    state.networkGroups = payload
  },
  SET_NETWORK_TAGS: (state, payload) => {
    state.networkTags = payload
  },
  SET_NETWORK_GROUPS_FILTERS: (state, payload) => {
    state.networkGroupsFilter = payload
  },
  SET_NEW_IMAGE: (state, payload) => {
    state.networkShow.logo_name = payload
  },

}

const actions = {
  getNetworks: ({commit}, params) => {
    getNetworks(params).then(resp => {
      commit('SET_NETWORKS', resp)
    }).catch(err => console.log(err))
  },
  getNetworksStatuses: ({commit}) => {
    getNetworksStatuses().then(resp => {
      commit('SET_NETWORKS_STATUSES', resp)
    }).catch(err => console.log(err))
  },
  getNetworksStatistic: ({commit}) => {
    getNetworksStatistic().then(resp => {
      commit('SET_NETWORKS_STATISTIC', resp)
    }).catch(err => console.log(err))
  },
  deleteNetwork: ({dispatch}, id) => {
    deleteNetwork(id).then(r => {
      Message({
        message: 'Network has been deleted',
        type: 'success',
        duration: 5 * 1000,
        showClose: true,
      })
    })
  },
  networkGroups: ({commit, dispatch}, idUser) => {
    networkGroups().then(r => {
      let filters = [];
      Object.values(r).forEach((value) => {
        filters.push({text:value.name, "value":value.slug})
      });
      commit('SET_NETWORK_GROUPS_FILTERS', filters)
      commit('SET_NETWORK_GROUPS', r)
    }).catch(err => {
      console.dir(err)
      if (err.response.status === 404) {
        console.log(router.push({name: 'not-found'}))
      }
    })
  },
  networkTags: ({commit, dispatch}, idUser) => {
    networkTags().then(r => {
      commit('SET_NETWORK_TAGS', r)
    }).catch(err => {
      console.dir(err)
      if (err.response.status === 404) {
        console.log(router.push({name: 'not-found'}))
      }
    })
  },
  networkShow: ({commit, dispatch}, idUser) => {
    networkShow(idUser).then(r => {
      commit('SET_NETWORK_SHOW', r.data)
    }).catch(err => {
      console.dir(err)
      if (err.response.status === 404) {
        console.log(router.push({name: 'not-found'}))
      }
    })
  },
  clearCurrentNetwork: ({commit}) => {
    commit('SET_NETWORK_SHOW', { logo_name: '' } )
  },
  uploadImage: ({commit, state}, file) => {

    return new Promise((resolve, reject) => {
      uploadImage(file).then(r => {
        console.log('r', r)
        commit('SET_NEW_IMAGE', r.logo)
        resolve(r)

      })

    })

    // commit('SET_NEW_IMAGE', payload)
  },
  updateNetworks: ({commit}, payload) => {
    updateNetwork(payload).then(r => {
      Message({
        message: 'Data updated',
        type: 'success',
        duration: 5 * 1000,
      })
    }).catch(err => console.dir(err))
  },
  createNetwork: ({commit}, payload) => {
    return new Promise((resolve, reject)=>{
      createNetwork(payload).then(resp => {
        resolve(resp)
      }).catch(err=> reject(err))
    }).catch(err => console.dir(err))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
